import { Box, Card, CardContent, Typography } from "@mui/material";
import { AppLineChart } from "../Charts/LineChart";

export const TotalSales = ({
  totalOrdersSale,
  isLoading,
  xAxisData,
  yAxisData,
  dateDifference,
  isCurrency,
}: {
  totalOrdersSale: number;
  isLoading: boolean;
  xAxisData: string[] | Date[] | number[];
  yAxisData: any[];
  dateDifference: number;
  isCurrency: boolean;
}) => {
  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center" fontWeight={"bold"}>
          Total Sales =&nbsp;
          <Typography fontWeight={"bold"}>
            ${totalOrdersSale.toFixed(2)}
          </Typography>
        </Box>
        <AppLineChart
          isLoading={isLoading}
          xAxisData={xAxisData}
          yAxisData={yAxisData}
          dateDifference={dateDifference}
          isCurrency={isCurrency}
        />
      </CardContent>
    </Card>
  );
};
